import React, { useEffect, useRef, useState } from 'react';
import { Auth } from 'aws-amplify';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import AdminNavTabs from '../components/AdminNavTabs';
import './AdminDashboard.css';

const PROJECT_NAME = process.env.REACT_APP_PROJECT_NAME || 'AppDemo';
const API_BASE_URL = process.env.REACT_APP_ADMIN_API_URL || process.env.REACT_APP_API_URL || '';

export default function AdminPosCallback() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const statusRef = useRef(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [statusMessage, setStatusMessage] = useState('');

  useEffect(() => {
    const run = async () => {
      try {
        setError('');
        setStatusMessage('');

        const code = String(params.get('code') || '').trim();
        const state = String(params.get('state') || '').trim();
        const envName = String(params.get('environment') || 'SANDBOX').trim().toUpperCase();
        const err = String(params.get('error') || '').trim();

        if (err) {
          setError(err);
          return;
        }

        if (!code) {
          setError('Missing code from Square callback.');
          return;
        }

        const session = await Auth.currentSession();
        const token = session.getIdToken().getJwtToken();

        const res = await fetch(`${API_BASE_URL}/admin/pos/connect/callback`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ code, state, environment: envName }),
        });

        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data?.error || 'Failed to complete Square connect');

        setStatusMessage('Square connected successfully.');
      } catch (e) {
        const msg = e?.message || 'Failed to complete Square connect';
        setError(msg);
      } finally {
        setLoading(false);
        try {
          statusRef.current?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
          statusRef.current?.focus?.({ preventScroll: true });
        } catch {
          // ignore
        }
      }
    };

    run();
  }, [params]);

  useEffect(() => {
    const guard = async () => {
      try {
        const session = await Auth.currentSession();
        const groups = session.getIdToken().payload['cognito:groups'] || [];
        if (!groups.includes('Admins')) {
          navigate('/admin/login');
        }
      } catch {
        navigate('/admin/login');
      }
    };

    guard();
  }, [navigate]);

  return (
    <div className="admin-dashboard">
      <header className="dashboard-header">
        <h1>{PROJECT_NAME} Admin</h1>
        <p>POS Connect Callback</p>
      </header>

      <AdminNavTabs />

      <main className="dashboard-content">
        <section className="dashboard-section">
          <div ref={statusRef} tabIndex={-1} />
          {loading ? <p>Processing…</p> : null}
          {error ? <p className="error-message">{error}</p> : null}
          {statusMessage ? <p className="success-message">{statusMessage}</p> : null}

          <p>
            <Link to="/admin/channels/pos">Back to POS</Link>
          </p>
        </section>
      </main>
    </div>
  );
}
